import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "page" };
const _hoisted_2 = {
    key: 0,
    class: "content"
};
const _hoisted_3 = { class: "balance-card" };
const _hoisted_4 = { class: "balance-top" };
const _hoisted_5 = { class: "balance-amount-row" };
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "balance-amount" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "stats-row" };
const _hoisted_10 = {
    key: 1,
    class: "hero-carousel-section"
};
import { ref, computed, onMounted, nextTick, useTemplateRef } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import SavedToSpendStatCard from './elements/SavedToSpendStatCard.vue';
import DiscountTransactionsSection from './elements/DiscountTransactionsSection.vue';
import MGWalkthrough from './elements/MGWalkthrough.vue';
import FaqsSection from './FaqsSection.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SavedToSpendPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getDiscountsStatement } = useVouchers();
        const { getWalkthrough, getFaqs } = useContent();
        const statementDays = ref([]);
        const statement = ref(null);
        const heroWalkthroughData = ref(null);
        const heroCarouselReady = ref(false);
        const faqs = ref([]);
        const transactionsDrawer = useTemplateRef('transactionsDrawer');
        const formattedBalance = computed(() => {
            return state.formatter.format(statement.value?.savedToSpendBalance || 0);
        });
        const formattedSavedLastYear = computed(() => {
            const value = statement.value?.rolling12MonthsSavings;
            return value ? state.formatter.format(value) : '£--';
        });
        const formattedAllTimeSavings = computed(() => {
            const value = statement.value?.allTimeSavings;
            return value ? state.formatter.format(value) : '£--';
        });
        const formattedAverageReward = computed(() => {
            const pct = statement.value?.averageSavingsPercentage || 0;
            return pct.toFixed(1) + '%';
        });
        function onLoad() {
            getCustomer(() => {
                getDiscountsStatement((result) => {
                    statement.value = result;
                    statementDays.value = result?.days || [];
                });
            });
            getWalkthrough('saved-to-spend-hero', (result) => {
                heroWalkthroughData.value = result;
            });
            getFaqs('save-to-spend', (result) => {
                faqs.value = result?.faqItems || [];
            });
        }
        function navigateToShop() {
            router.push('/shopvouchers');
        }
        function navigateToFullStatement() {
            nextTick(() => {
                if (transactionsDrawer.value) {
                    transactionsDrawer.value.openDrawer();
                }
            });
        }
        function handleHeroSlideChange() {
            // Handle slide change if needed
        }
        function determineCarouselHeight() {
            if (window.innerHeight < 700) {
                return '150px';
            }
            else {
                return '240px';
            }
        }
        onMounted(() => {
            onLoad();
            setTimeout(() => {
                heroCarouselReady.value = true;
            }, 50);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(HeaderBlock, { title: "Saved to Spend" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer && statement.value,
                    cardBlocks: true,
                    withTopCard: true
                }, null, 8, ["customer"]),
                (_unref(state).customer && statement.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "balance-title" }, "Your Saved to Spend pot", -1)),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("img", {
                                        src: require('@/assets/icons/coins-swap.png'),
                                        alt: "coins",
                                        class: "balance-icon"
                                    }, null, 8, _hoisted_6),
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(formattedBalance.value), 1)
                                ]),
                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "balance-divider" }, null, -1)),
                                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "balance-description" }, "The cashback you have earned through buying vouchers will show here. You earn rewards when spending from your pot too!", -1)),
                                _createElementVNode("button", {
                                    class: "shop-button",
                                    onClick: navigateToShop
                                }, [
                                    _cache[0] || (_cache[0] = _createElementVNode("span", null, "Shop", -1)),
                                    _createElementVNode("img", {
                                        src: require('@/assets/arrow-right.png'),
                                        alt: "arrow",
                                        class: "arrow-icon"
                                    }, null, 8, _hoisted_8)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(SavedToSpendStatCard, {
                                    icon: require('@/assets/icons/credit-card-plus.png'),
                                    label: "Saved in the last year",
                                    value: formattedSavedLastYear.value,
                                    variant: "gold"
                                }, null, 8, ["icon", "value"]),
                                _createVNode(SavedToSpendStatCard, {
                                    icon: require('@/assets/icons/shopping-bag.png'),
                                    label: "All time savings",
                                    value: formattedAllTimeSavings.value,
                                    variant: "blue"
                                }, null, 8, ["icon", "value"]),
                                _createVNode(SavedToSpendStatCard, {
                                    icon: require('@/assets/icons/coins-stacked.png'),
                                    label: "Average reward",
                                    value: formattedAverageReward.value,
                                    variant: "purple"
                                }, null, 8, ["icon", "value"])
                            ])
                        ]),
                        (statementDays.value && statementDays.value.length > 0)
                            ? (_openBlock(), _createBlock(DiscountTransactionsSection, {
                                key: 0,
                                days: statementDays.value,
                                formatter: _unref(state).formatter,
                                maxDays: 3,
                                maxVouchers: 3,
                                onViewMore: navigateToFullStatement
                            }, null, 8, ["days", "formatter"]))
                            : _createCommentVNode("", true),
                        (heroWalkthroughData.value && heroCarouselReady.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(MGWalkthrough, {
                                    walkthroughData: heroWalkthroughData.value,
                                    variant: "sheet",
                                    compact: true,
                                    imageHeight: '220',
                                    height: determineCarouselHeight(),
                                    onSlideIndexChanged: handleHeroSlideChange
                                }, null, 8, ["walkthroughData", "height"])
                            ]))
                            : _createCommentVNode("", true),
                        (faqs.value.length)
                            ? (_openBlock(), _createBlock(FaqsSection, {
                                key: 2,
                                class: "faq-section",
                                faqs: faqs.value,
                                limit: 5,
                                faqName: "save-to-spend"
                            }, null, 8, ["faqs"]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(DrawerPanel, {
                    ref_key: "transactionsDrawer",
                    ref: transactionsDrawer,
                    bottom: "-18px",
                    openHeight: "95%",
                    closedHeight: "0px",
                    title: "All Activity",
                    backgroundColor: "white",
                    openBackgroundColor: "white"
                }, {
                    default: _withCtx(() => [
                        (statementDays.value && statementDays.value.length > 0)
                            ? (_openBlock(), _createBlock(DiscountTransactionsSection, {
                                key: 0,
                                days: statementDays.value,
                                formatter: _unref(state).formatter,
                                title: ""
                            }, null, 8, ["days", "formatter"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 512)
            ]));
        };
    }
});
